module.exports = __webpack_public_path__ + "img/midBox_img.974414b7.png";